<template>
  <div class="container d-flex justify-content-center">
    
  <div v-if="!isLogged">
  <div class="col-auto">
    <label for="inputPassword2" class="visually-hidden">Password</label>
    <input type="password" v-model="pass" class="form-control" id="inputPassword2" placeholder="Password">
  </div>
  <div class="col-auto">
    <button  class="btn btn-primary mb-3 mt-3" @click="signIn"><strong>Zaloguj się</strong></button>
  </div>
  
  </div>
<div v-if="isLogged">
  <div class="card " style="width: 20rem;">
  <div class="card-header">
    <strong>Głosowanie</strong>
  </div>
  <div class="p-3">
    <div class="mb-1">Wybierz listę kandydatów</div>
<select class="form-select" size="3" aria-label="Size 3 select example" v-model="selected">
  
  <option value="1">0-3</option>
  <option value="2">4+</option>
  
</select>
<div class="d-grid gap-2">
    <button  class="btn btn-danger mb-1 mt-3 " :disabled="(selected!=1 && selected!=2) || timeToEnd>0" @click="startVoting"><strong>
      <span v-if="timeToEnd>0" > pozostało: {{timeToEndFormated}}</span>
      <span v-else> Rozpocznij</span>
        </strong></button>
</div>
 <router-link target="_blank" to="/results">Otwórz stronę z zegarem i wynikami</router-link>
</div>
</div>


</div>
</div>
</template>

<script>

export default {
  name: 'AdminView',
  components: {
    
  },
  data: function () {
return {
    pass: '',
    timeNow: Date.now(), 
    selected: null, 
    interval: undefined
}
},
  mounted(){
   // this.$store.dispatch('loginAsAnon')
    this.$store.dispatch('loadConf', 'admin')
    this.$store.dispatch('onLogin')
    this.interval = setInterval(this.loadTime, 1000);
    
  },
  methods:{
    signIn(){
      this.$store.dispatch('loginAsAdmin',this.pass)
    },
    loadTime(){
      this.timeNow = Date.now();
    },
    startVoting(){
      this.$store.dispatch('startVoting',this.selected)
    }
  },
  computed:{
     uid(){return this.$store.state.uid},
     isLogged(){return this.uid == this.$store.state.adminUID},
    // members(){return this.$store.state.members},
    // isLogged(){return this.$store.state.isLogged},
     timeToEnd(){return this.$store.state.endTime - this.timeNow},
     timeToEndFormated(){
      
      if(this.timeToEnd > 0){
        let seconds = Math.floor( (this.timeToEnd/1000) % 60 );
        let minutes = Math.floor( (this.timeToEnd/1000/60) % 60 );
        if(seconds < 10) seconds = "0"+seconds
        return minutes+":"+seconds
      } else return ''
      
    }
    // isVoted(){return this.$store.state.vote >= 0},
    // isLoaded(){return this.$store.state.vote != undefined && this.isLogged},
    // isActivated(){return this.$store.state.activated}
  }
}
</script>
